export default "__VITE_ASSET__Deber0FM__"